<div class="job-status-container">
    <div class="progress-line"></div>
    <div *ngFor="let step of jobSteps; let i = index" class="step">
      <i [class]="getIconClass(step, i) + ' ' + getAnimationClass(i) + ' ' + getColorClass(i)" class="status-icon"></i>
      <span class="step-label">{{ step }}</span>
    </div>
  </div>
  